// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Duomenų prekybos centras",
        "pull_refresh": "Patraukite žemyn, kad atnaujintumėte",
        "release_refresh": "Atleiskite atnaujinti",
        "refresh_loading": "Įkeliama ...",
        "footer_text": "Paslaugos teikia Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Paieškos šalis/regionas",
        "my_flow": "Mano duomenys",
        "charge_code": "Kupono kodas",
        "coupons": "Kuponai",
        "local_package": "Vietiniai duomenys",
        "more": "Daugiau",
        "popular_destination": "Šalis/regionas",
        "buy_now": "Pirkite dabar",
        "package_useing": "Aktyvus",
        "unused": "Neaktyvus",
        "download_app": "Atsisiųskite programėlę",
        "enter_the_mall_list": "Eikite į prekybos centro sąrašą",
        "no_data": "Nėra duomenų",
        "no_data_available": "Nėra duomenų",
        "copy_success": "Kopijuoti sėkmingai",
        "copy_fail": "Kopijuoti nepavyko",
        "meritsTitle": "Kokie yra privalumai?",
        "merits1": "Be SIM kortelės & Be mėnesinių mokėjimų",
        "merits2": "Integruota su top 2-3 operatoriais automatiškai perjungti tinklą",
        "go_buy": "Eik pirkti",
        "instant_savings": "Sutaupyti",
        "expires_in": "Baigiasi už",
        "download_app_tips": "Atsisiųskite programėlę, kad gautumėte daugiau pasiūlymų ir patirčių"
    },
    "packages": {
        "sub_title": {
            "us": "Išskyrus Guamą, Saipanas",
            "it": "Įskaitant Vatikano miestą, San Mariną",
            "va": "Įskaitant Italiją, San Mariną",
            "sm": "Įskaitant Italiją, Vatikano miestą",
            "ma": "Įskaitant Vakarų Sacharą",
            "eh": "Įskaitant Maroką",
            "ch": "Įskaitant Lichtenšteiną",
            "li": "Įskaitant Šveicariją",
            "fr": "Įskaitant Monaką",
            "mc": "Įskaitant Prancūziją",
            "fi": "Įskaitant Alando salas",
            "ax": "Įskaitant Suomiją",
            "gu": "Įskaitant Šiaurės Marianos salas",
            "mp": "Įskaitant Guamą"
        },
        "unlimited_packages": "Neribotas duomenų paketas",
        "normal_packages": "Normalus duomenų paketas",
        "multi_region_packages": "Daugiakregionas",
        "regional_data": "Regioninės duomenys",
        "high_speed_text": "Didelės spartos duomenys",
        "infiniteFlow": "Neierobežoti dati",
        "unLimitData": "Begrįžiamas",
        "high_speed_text_year": "Didelės spartos duomenys/mėn",
        "package_list": "Paketų sąrašas",
        "special_offer": "Akcijos",
        "first_month": "1. Mėnuo",
        "periodUnit": {
            "day": "diena (-os)",
            "month": "mėnuo",
            "hour": "valanda (-os)",
            "year": "metai"
        },
        "periodUnits": {
            "day": "diena (-os)",
            "month": "mėnesiai",
            "hour": "valanda (-os)",
            "year": "metai"
        },
        "periodUnitSimp": {
            "day": "d",
            "month": "už",
            "hour": "h",
            "year": "līdz"
        },
        "periodUnitMonthly":"Mėnesinis",
        "periodUnitsSimp": {
            "day": "d",
            "month": "už",
            "hour": "h",
            "year": "līdz"
        },
        "unlimited_good_name": {
            "day": "Dienos praėjimas",
            "month": "Mėnesio leidimas",
            "year": "Kasmet"
        },
        "continuousMonth": "Ištisiniai mėnesiai",
        "continuousDay": "Nuolatinės dienos",
        "continuousYear": "Ištisiniai metai",
        "day_invalid": "Pasibaigti dabartinę dieną",
        "month_invalid": "Pasibaigimas dabartiniu mėnesį",
        "immediate_valid": "Iškart įsigalioja",
        "tomorrow_day_valid": "Veiksminga nuo kitos dienos",
        "tomorrow_month_valid": "Veiksminga nuo kito mėnesio",
        "detail": {
            "cell_flow": "Duomenys",
            "cell_period": "Galiojimas",
            "buy_quantity": "Suma",
            "use_area": "Aprėptis",
            "use_intro": "Sąlygos ir sąlygos",
            "buy_btn": "Įsakymas",
            "pay": "‌Mokėti",
            "buy_tips": "Turite %@packageName paketą naudojamą. Ar norite pirkti šį paketą?",
            "haveOrderTips": "Sukurta užsakymas su laukiančiu mokėjimu. Spustelėkite Patvirtinti pereinant į mano duomenų puslapį！"
        },
        "confirm": {
            "title": "Užsakymo patvirtinimas",
            "real_pay_amount": "Sumokėta suma",
            "online_payment": "Mokėjimas internetu",
            "create_order_error": "Sąranka nepavyko"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Gauti užsakymo būseną ...",
            "buy_success": "Užsakymas baigtas",
            "buy_pending": "Laukiantis patvirtinimas",
            "buy_pending_tip": "Maksājums procesā… ja maksājums netika pārsūtīts 10 minūšu laikā, lūdzu, sazinieties ar mums, lai saņemtu atbalstu.",
            "get_payment_info_fail": "Mokėjimo informacijos įsigijimas nepavyko",
            "cell_package": "Paketas",
            "cell_buy_amount": "Zems",
            "cell_real_amount": "Sumokėta suma",
            "go_to_order_btn": "Dodieties uz manu paketi",
            "back_home": "Atpakaļ uz mājām",
            "back_mall": "Atpakaļ uz tirdzniecības centru",
            "ordersn_empty": "Užsakymas SN negali būti tuščias",
            "order_search_error": "Netikėta klaida",
            "goodsName": 'Produkto pavadinimas'
        },
        "fail": {
            "payment_fail": "Maksājums neizdevās",
            "back_home": "Atpakaļ uz mājām"
        }
    },
    "CountryGroup": {
        "title": "Šalis/regionas",
        "placeholder": "Ieškokite šalį ar regioną",
        "clear": "Aišku",
        "history": "Paieškos istorija"
    },
    "PromotionCode": {
        "verification": {
            "title": "Kupono kodas",
            "minititle": "Kupono kodas",
            "input": "Įveskite papildymo kodą",
            "explain": "Patarimai: Palieskite mygtuką „Nuskaitymo“ mygtukas viršutinėje dešinėje, kad nuskaitytumėte vaučerio kortelės QR kodą, arba rankiniu būdu įveskite voucher kodą („Case Off“), jei jis neveikia.",
            "submit": "Pateikti",
            "exchange": "Išpirkti",
            "cancel": "Atšaukti",
            "Inquiry": "Ar tikrai mainai",
            "ErrorCode": "Uzlādēšanas koda kļūda"
        },
        "recharge_success": {
            "package": "Paketas",
            "content": "Sėkmingai išpirktas",
            "back": "Grįžkite į prekybos centrą",
            "view_packets": "Dodieties uz manu paketi"
        }
    },
    "order": {
        "state": {
            "inUse": "Aktyvuota",
            "isFirst": "Prioritetas",
            "toFirst": "Nustatykite prioritetą",
            "inactive": "Inaktyvuotas"
        },
        "periodUnits": {
            "minute": "minutė (-os)",
            "hour": "valanda (-os)",
            "day": "diena (-os)",
            "month": "mėnuo (-ai)"
        },
        "useIntro": {
            "tip1": "Neribotas duomenų paketas turi didesnį prioritetą nei tūrio duomenų paketas.",
            "tip2": "Naudojimo prioritetas bus pagrįstas to paties tipo paketo pirkimo data, t. Y. Pakaotė su ankstyviausia pirkimo data bus naudojama pirmiausia, o vieno regiono paketų prioritetas yra didesnis nei regioninis paketas.",
            "tip3": "Taip pat galite rankiniu būdu pakoreguoti to paties tipo paketų naudojimo prioritetą."
        },
        "myFlow": "Mano duomenys",
        "remainingFlow": "Liko duomenys",
        "remainingTime": "Galiojanti kairė",
        "remainingHighFlow": "Didelės spartos duomenys liko",
        "validPeriod": "Galiojimas",
        "noneFlow": "Nėra duomenų paketo",
        "noneFlowTip": "Įsigykite duomenų paketą ir mėgaukitės aukštos kokybės tinklu",
        "buyPackFlow": "Pirkti paketus",
        "checkInvalidFlow": "Patikrinkite, ar galiojimo laikas pasibaigęs duomenų paketas",
        "orderList": {
            "title": "mano užsakymai",
            "amount_paid": "Iš viso",
            "device": "Priklausomas įrenginys",
            "order_details": "Užsakymo detalės",
            "total_amont": "Tarpinė suma",
            "orderSN": "Užsakymas Nr.",
            "createTime": "Kūrimo laikas",
            "cancelTime": "Uždarytas laikas",
            "payTime": "Užsakymo laikas",
            "unsubTime": "Atšauktas laikas",
            "payMethod": "Mokėjimo būdas",
            "thirdSN": "Sandorio Nr.",
            "delete": "Ištrinti",
            "cancel": "Atšaukti užsakymą",
            "unsub": "Grąžinti pinigus",
            "goto_cancel": "Ar norite atšaukti užsakymą?",
            "goto_unsubscribe": "Ar norite atšaukti užsakymą?",
            "delete_Tips": "Užsakymas negali būti atnaujintas po to, kai jis buvo ištrintas, todėl jūsų po aptarnavimo problemos nebus išspręstos.Ar tikrai jį ištrinsite?",
            "status_success": "Atlikta",
            "status_pending": "Neapmokėta",
            "status_cancel": "Uždaryta",
            "status_unsub": "Atšaukta",
            "payMethod_stripe": "Kreditinė kortelė"
          },
    },
    "registerlogin": {
        "create_account_tip":"Sukurkite sąskaitą, pradėkite išskirtinę patirtį",
        "select_country_tip":"Įrenginys Naudokite šalį/regioną",
        "email_name": "Paštas",
        "phone_name": "Telefonas",
        "email_address": "El. Pašto adresas",
        "password": "slaptažodis",
        "country": "šalis",
        "select_country": "Pasirinkite šalį",
        "cancel": "Atšaukti",
        "confirm": "Žinoma",
        "please_enter": "Įveskite 6-20 simbolių (raidžių, skaičių ar simbolių derinys)",
        "select_country_tips": "Šalies pasirinkimas skirtas vietinių paketų žiūrėjimui. Po registracijos to negalima pakeisti. Prašau patvirtinti!",
        "global_roaming": "Tarptautinis domeno kodas",
        "phone_number": "Telefono numeris",
        "agree": "sutikti",
        "user_agreement": "Vartotojo sutartis",
        "and": "ir",
        "privacy_policy": "Privatumo politika",
        "register_login": "Prisiregistruokite arba prisijunkite",
        "login_error": "Prisijungimų skaičius yra per dažnas, bandykite dar kartą vėliau!",
        "register_error": "Registracijų skaičius yra per dažnas, bandykite dar kartą vėliau!",
        "forgot_pwd": "Pamirškite slaptažodį",
        "app_tips": "Prisijunkite prie programos su šia paskyra, atsisiųsdami ją, kad pasiektumėte daugiau funkcijų.",
        "download_app": "Eikite atsisiųsti programos",
        "rememberPwd": "Prisiminkite slaptažodį",
        "third_login": "Tęsti",
        "agreement_tips": "Patikrinkite vartotojo sutarties ir privatumo politikos laukelį",
        "selectCountry_tips": "Prašome atkreipti dėmesį, kad registruota šalis tiesiogiai paveiks šiuos mokėjimo būdus ir valiutas. Pasirinkite pagal jūsų poreikį.",
        "login_error_cancel": "Naudotojas atšaukė prisijungimą",
        "login_error_auth": "Leiskite naršyklės nustatymuose pop-up langus",
        "device_tips": "Įrenginys laukia aktyvavimo. Apdorojimas per 24 valandas."
    },
    "forgotPwd": {
        "forgot_pwd": "Pamirškite slaptažodį",
        "email_address": "El. Pašto adresas",
        "next": "Kitas",
        "email_has_been_sent": "Mes išsiuntėme el. Laišką %@email. Pašto adresu. Spustelėkite nuorodą ir atlikite veikmus, kad gautumėte slaptažodį.",
        "have_retrieved_it": "Aš tai radau",
        "unable_to_receive_email": "Negalite gauti el. Laiško? Patikrinkite, ar yra el. Laiškų iš %@email. Paštas po jūsų šlamštu ir ištrintas pašto katalogas",
        "or": "arba",
        "resend": "Iš naujo",
        "global_roaming": "Tarptautinis domeno kodas",
        "phone_number": "Telefono numeris",
        "verification_code_has_been_sent": "Mes išsiuntėme patvirtinimo kodą į:",
        "verification_code": "Patikrinimo kodas",
        "no_verification_code_received": "Negavote patvirtinimo kodo?",
        "please_enter": "Įveskite 6-20 simbolių (raidžių, skaičių ar simbolių derinys)",
        "reset_password": "Iš naujo nustatykite slaptažodį",
        "reset_successful": "Sėkmingai iš naujo nustatyti"
    },
    "coupons": {
        "coupons_name": "Kuponai",
        "no_coupons": "Dar nėra kuponų",
        "no_data": "Dar nėra duomenų",
        "applicable_to_the_following": "Kuponai yra tinkami šiam duomenų pakete"
    },
    "digital":{
        "title":"Įrenginys SN",
        "purchased":"Mano pirkiniai",
        "viewAll":"Daugiau",
        "skinStore":"Produktų parduotuvė",
        "completed":"Įsigytas",
        "goBuy":"Pirkti",
        "order": {
          "title":"Įsigyti užsakymai"
        },
        "detail": {
          "describe":"Aprašymas"
        }
    },
    "viewPL": {
        "other": 'kiti'
    },
    "invalidFlow": {
        "stateName": "Būsena",
        "state": {
            "NOT_ACTIVATED": "Inaktyvuotas",
            "IN_USING": "Galimas",
            "USE_END": "Išsekęs",
            "EXPIRE": "Pasibaigė",
            "TRANSFER": "Perduoti",
            "UNSUBSCRIBE": "Atšaukti",
            "VALID": "Galioja",
            "INVALID": "Negaliojantis",
            "EXCHANGE_POINTS": "Išpirkti taškus"
        },
        "noneFlow": "Nėra duomenų paketo, kurio galiojimo laikas pasibaigė",
        "pageName": "Duomenų paketas pasibaigęs"
    },
    "flowDetail": {
        "title": "Duomenų informacija",
        "flow": "Duomenys",
        "validTime": "Galiojantys pradžios",
        "invalidTime": "Galioja iki",
        "coverage": "Aprėptis",
        "useIntro": "Sąlygos ir sąlygos",
        "purchaseTime": "Pirkimo laikas",
        "subtotal": "Mokėjimo suma",
        "status": "Būsena",
        "cancel": "Atšaukti",
        "buyAgain": "Pirkite dar kartą",
        "validity": "Galiojimas",
        "tip": "Pranešimas",
        "cancelTip": "Ar tikrai norite grąžinti šį paketą?",
        "dataLeft": "Liko duomenys"
    },
    "netError": {
        "try_again": "Bandykite dar kartą",
        "net_error": "Nėra tinklo",
        "try_again_desc": "Patikrinkite tinklo nustatymą ir bandykite dar kartą"
    },
    "loadFail": {
        "try_again": "Bandykite dar kartą",
        "load_fail": "Įkėlimas nepavyko",
        "load_fail_desc": "Duomenų įkėlimas nepavyko, bandykite dar kartą",
        "IMEI_Not_Exist": "IMEI neegzistuoja, pabandykite įeiti iš dešiniojo įėjimo",
        "Project_Not_Exist": "Įvyksta klaida. Kreipkitės į klientų aptarnavimą. (01)",
        "commonError": "Įvyksta klaida. Kreipkitės į klientų aptarnavimą."
    },
    "settlement_Easy_and_convenient": "Lengva ir patogu",
    "settlement_Great_deal": "Labai daug",
    "settlement_Safe_and_secure": "Saugus ir saugus",
    "settlement_Autopay_service_regulation": "Automatinio mokėjimo paslaugos reglamentas",
    "settlement_Read": "Perskaitykite",
    "settlement_No_coupon": "Dar nėra kuponų",
    "settlement_Subtotal": "pradinė kaina",
    "settlement_Coupon": "Kuponas",
    "settlement_TOTAL": "Kopsumma",
    "settlement_promotion_tip": "Reklaminio pasiūlymo negalima naudoti kartu su jokiais kuponais",
    "settlement_coupon_tip": "Kupono negalima naudoti kartu su jokiais kitais reklaminiais pasiūlymais",
    "member_myFlow_noList": "Jokių duomenų",
    "detail_se_content": "Saugus, lengvas ir patogus būdas. Galite bet kada atsisakyti prenumeratos.",
    "Enter_Promo_code": "Reklamos kodas",
    "Enter_Promo_Coupon": "Kuponai",
    "settlement_Not_used_coupon": "Kuponas nenaudojamas",
    "settlement_Available_coupon": "Galimas",
    "settlement_Unavailable_coupon": "Nepasiekiamas",
    "please_Enter_Promo_code": "Įveskite reklamos kodą",
    "please_Select_Coupon_use": "Pasirinkite kuponą, kurį norite naudoti.",
    "Buy_Now": "Pirkite dabar",
    "Dont_Use_Any": "Nenaudokite nė vieno",
    "settlement_confirm": "Patvirtinti",
    "settlement_tips": "Patvirtinti",
    "flowDetail_unsubscribe": "Atsisakyti prenumeratos",
    "flowDetail_unsubscribed": "Nenubirštas",
    "flowDetail_isCancelPackage": "Atsisakykite šio paketo?",
    "flowDetail_confirmAgreementUnsubscribe": "Po atsisakymo negalima daug ką turėti. Ar tikrai norite atsisakyti prenumeratos?",
    "flowDetail_cancel": "Atšaukti",
    "flowDetail_cancelSuccess": "Sėkmingai atsisakyti prenumeratos",
    "packages_detail_promotion": "Reklama",
    "orderTips":{
        "iDay" : "diena",
        "iDays" : "dienos",
        "iMonth" : "mėnuo",
        "iMonths" : "mėnesiai",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Pirmajame pirkime, Mokėkite %@money/%@periodSymbol vėliau, Galite bet kada atsisakyti prenumeratos",
        'Monthly_discount':"Išsaugokite %@saveMoney kiekvienas %@period! Galite bet kada atsisakyti prenumeratos",
        'Ordinary_monthly_package':"Saugus, lengvas ir patogus būdas. Galite bet kada atsisakyti prenumeratos",
        "AlreadyPurchased":'Atsiprašome, kad šiuo metu galite užsiprenumeruoti tik vieną duomenų paketą. Prašome atsisakyti “%@” prenumeratos ir vėliau užsiprenumeruokite bet kurį norimą paketą pasibaigus.',
        "Contract_recommendation_First":'<label>Naudodamiesi „Autopay“ paslauga, pirmajame pirkime mokėkite tik</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Galite bet kada atsisakyti prenumeratos'
        +'<a class="btn">Prenumeruokite ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Naudodami „Autopay“ paslaugą, mokėkite tik</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Galite bet kada atsisakyti prenumeratos'
        +'<a class="btn">Prenumeruokite ></a></p>',
        "Contract_recommendation_General":"<label>Su „Autopay“ paslauga</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Saugus, lengvas ir patogus būdas. Galite bet kada atsisakyti prenumeratos'
        +'<a href="javascript:;" class="btn">Prenumeruokite ></a></p>',
        'BanlanceDoubleCheck':'Ar tikrai norite susimokėti su balansu?',
    },
    feedback: {
        title: "atsiliepimai",
        placeholder: "Įeikite į šalį, kurioje norite apsilankyti, ar kitus klausimus, ir mes kuo greičiau patenkinsime jūsų poreikius!",
        submit: "Pateikti",
        submit_success: "Sėkmingai pateikta",
        other_opinions: "Kitos nuomonės"
    },
    view_country_input: 'Įveskite savo paskyrą',
    "select_package": {
        "title": "Pasirinkite Duomenis",
        "allPackage": "Visi Duomenys",
        "type": "Tipas",
        "flow": "Duomenys",
        "month_package": "Mėnesinis planas",
        "flow_package": "Duomenų paketas",
        "time": "Trykmis",
        "period": "Ciklas",
        "auto_debit": "Info Autodebitas",
        "auto_subscribe": "Auto-Pratęsimas",
        "detail": "Duomenų Detalai",
        "carrier": "Palaikomi Operatoriaus",
        "country": "Apžvelgtos Šalys",
        "notice": "Pirkimo Vadovas"
    }
}